// extracted by mini-css-extract-plugin
module.exports = {"resampleSelectorRoot":"hdqbbqxS","styledChip":"r7qbUYKS"};